<script lang="ts">
  import { ENGINE_VERSION } from '@atlasguess/engine';
  import Globe from '../components/Globe.svelte';
  import { withPageTitle } from '../lib/page-title';

  $effect(() => withPageTitle('Engine demo'));
</script>

<div class="demo-page">
  <Globe />

  <div class="demo-page__caption">
    <span class="mono-label">Atlas Engine</span>
    <span class="mono-caption">v{ENGINE_VERSION} · drag to rotate · scroll to zoom</span>
  </div>
</div>
